import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { categoryLogosForPrerender } from '../../../../../../../redux/product-listing/product-listing.selectors';
import { LogoCategoriesPrerenderComponent } from './logo-categories-prerender';
const selector = createStructuredSelector({
  logos: categoryLogosForPrerender
});
export const LogoCategoriesPrerender = connect(selector)(LogoCategoriesPrerenderComponent);